import { FORUM_NOT_INSTALLED_ERROR } from '../constants/errors';

export const handleInitialRequestFailure = (error: any) => {
  if (error && error.status === 404) {
    throw FORUM_NOT_INSTALLED_ERROR;
  }

  throw error;
};
